import React from 'react';
import { Award } from '../../../shared/assets/AppIcons';
import { Badge } from '@/shared/ui/badge';

export default function StaffSkillsSection({ skills = [], compact = false }) {
  const content = (
      <div className="flex flex-wrap gap-2">
        {skills.length > 0 ? (
          skills.map((skill, index) => (
            <Badge key={`${skill}-${index}`} variant="outline" className={compact ? 'staff-detail__skill' : 'staff-skill-badge'}>
              {skill}
            </Badge>
          ))
        ) : (
          <p className="staff-section__muted">Nessuna competenza registrata</p>
        )}
      </div>
  );
  if (compact) return content;
  return (
    <div className="staff-section-card">
      <div className="staff-section-card__header">
        <Award size={16} />
        <h3>Competenze</h3>
      </div>
      {content}
    </div>
  );
}
